import React from "react";
import ModuleFactory from "../../Modules/ModuleFactory";
import TitleArea from "../../Components/TitleArea";
import WYSIWYGContent from "../../Components/WYSIWYGContent";
import { ContentContainer } from "../../../styles";
import { GridPost } from "../PostTemplate/styled";

export default function FullWidthTemplate({ title, content, modules }) {
  const hasHero =
    modules &&
    modules.some(
      (module) =>
        module &&
        ("hero" === module.section_name || "qip_hero" === module.section_name)
    );

  return (
    <ContentContainer>
      {Boolean(title) && !hasHero && <TitleArea title={title} area="pages" />}
      {content && (
        <GridPost>
          <WYSIWYGContent content={content} />
        </GridPost>
      )}
      {modules &&
        modules.map((module, i) => <ModuleFactory module={module} key={i} />)}
    </ContentContainer>
  );
}
